module.exports = __webpack_public_path__ + "img/c66.72740cd5.png";